import { render, staticRenderFns } from "./EditarListaDistribucionModal.vue?vue&type=template&id=59720733&"
import script from "./EditarListaDistribucionModal.vue?vue&type=script&lang=ts&"
export * from "./EditarListaDistribucionModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('59720733', component.options)
    } else {
      api.reload('59720733', component.options)
    }
    module.hot.accept("./EditarListaDistribucionModal.vue?vue&type=template&id=59720733&", function () {
      api.rerender('59720733', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/ListaDistribucion/EditarListaDistribucionModal.vue"
export default component.exports